import type React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  SvgIconProps,
} from "@mui/material";

interface MetricCardProps {
  value?: number;
  title: string;
  badge?: string;
  icon?: React.ComponentType<SvgIconProps>;
  color?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  value,
  title,
  badge,
  icon: Icon,
  color,
}) => {
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxShadow: 0,
        borderRadius: 3,
        p: 1,
        textAlign: "center",
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-end",
          pb: 1,
        }}
      >
        {Icon && <Icon sx={{ fontSize: 32, color, mb: 1 }} />}
        {value !== undefined && (
          <Typography variant="h4" component="div">
            {value.toLocaleString()}
          </Typography>
        )}
        <Typography color="textSecondary" gutterBottom variant="h6">
          {title}
        </Typography>

        {badge && (
          <Box
            sx={{
              ...(badge.toLowerCase().includes("overdue")
                ? {
                    backgroundColor: "rgba(255, 59, 48, 0.1)",
                    color: "#FF3B30",
                  }
                : {
                    backgroundColor: "rgba(76, 175, 80, 0.1)",
                    color: "#4CAF50",
                  }),
              borderRadius: 2,
              px: 1,
              py: 0.5,
              display: "inline-block",
              fontSize: "0.75rem",
              fontWeight: 500,
              mt: 0.5,
            }}
          >
            {badge}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MetricCard;
